<template>
  <div class="match">
    <div class="top-content">
      <div class="wd">
        <Row type="flex" justify="space-around">
          <i-col span="19" class="carousel">
            <Carousel autoplay loop>
              <Carousel-item>
                <svg-icon icon-class="u1" class="wrap"></svg-icon>
              </Carousel-item>
              <Carousel-item>
                <svg-icon icon-class="u2" class="wrap"></svg-icon>
              </Carousel-item>
              <Carousel-item>
                <svg-icon icon-class="u3" class="wrap"></svg-icon>
              </Carousel-item>
            </Carousel>
          </i-col>
          <i-col span="5">
            <svg-icon icon-class="u4" class="wrap-right"></svg-icon>
            <div class="work">
              <p>
                <svg-icon
                  icon-class="u8"
                  @click="isShowCourse = true"
                  style="font-size: 25px; margin-right: 10px"
                ></svg-icon>
                <span @click="isShowCourse = true">开始创作</span>
              </p>
              <p>
                <svg-icon
                  icon-class="u9"
                  style="font-size: 22px; margin-right: 10px"
                ></svg-icon>
                <!-- @click="isShowBat = true" -->
                <span>
                  <a href="#match" style="color: black !important">我要参赛</a>
                </span>
              </p>
            </div>
          </i-col>
        </Row>
      </div>
    </div>
    <div class="wd">
      <div class="match-content">
        <Row class="work-file">
          <i-col span="19">
            <div class="title">
              <svg-icon icon-class="star" class="icon"></svg-icon>
              <span class="tip">团队赛最新排位</span>
            </div>
            <Carousel>
              <Carousel-item v-for="i in caroulLength" :key="i.id">
                <Row type="flex" style="margin: 20px 0">
                  <i-col
                    span="5"
                    class="card-list"
                    v-for="(item, index) in workList.slice((i-1)*8, i*8)"
                    :key="index"
                  >
                    <Card :shadow="true" class="card">
                      <div class="pic" @click="toDetail(item.id)">
                        <img :src="item.coverFileUrl" alt />
                      </div>
                      <div class="content">
                        <p class="title">{{ item.workName }}</p>
                        <Icon class="vm" type="md-eye" size="22" color="#999" />
                        <span
                          class="vm"
                          style="font-size: 13px; margin-right: 19px"
                          >{{ item.viewNum }}</span
                        >
                        <Icon
                          class="vm"
                          type="md-thumbs-up"
                          size="23"
                          color="#999"
                        />
                        <span class="vm" style="font-size: 13px">
                          {{ item.starNum }}
                        </span>
                      </div>
                      <Row type="flex" align="middle" class="footer">
                        <i-col>
                          <svg-icon
                            class="vm"
                            style="font-size: 25px; margin-right: 8px"
                            icon-class="user"
                            @click="toFriend(item.userId)"
                          ></svg-icon>
                          <span class="vm" @click="toFriend(item.userId)">
                            {{ item.realname }}
                          </span>
                        </i-col>
                      </Row>
                    </Card>
                  </i-col>
                </Row>
              </Carousel-item>
            </Carousel>
          </i-col>

          <i-col span="5">
            <div class="title">
              <svg-icon icon-class="u7" style="font-size: 32px"></svg-icon>
              <span class="tip">个人赛获奖作品</span>
            </div>
            <List class="list">
              <ListItem v-for="(item, index) in winWork" :key="index">
                <div
                  @click="
                    showWinWork = true;
                    winWorkVideoUrl = item.videoUrl;
                  "
                >
                  <ListItemMeta :avatar="item.coverUrl" :title="item.title" />
                  <span class="grade">{{ item.score }}</span>
                </div>
              </ListItem>
              <p>查看更多榜单</p>
            </List>
          </i-col>
        </Row>

        <div class="title" id="match">
          <svg-icon icon-class="u6" style="font-size: 32px"></svg-icon>
          <span class="tip">比赛进行中</span>
        </div>
        <Row class="cards" type="flex">
          <i-col
            span="12"
            class="card-list2"
            v-for="(item, index) in contestResult.records"
            :key="index"
          >
            <Card :shadow="true" class="card">
              <!-- <svg-icon icon-class="u5"
              class="icon"></svg-icon>-->
              <img style="width: 100%" :src="item.coverUrl" alt />
              <div class="card-bottom">
                <Row class="title" type="flex" justify="space-around">
                  <i-col span="20">{{ item.conetestName }}</i-col>
                  <i-col span="4" class="status">进行中</i-col>
                </Row>
                <p>主办单位：{{ item.organizer }}</p>
                <p>报名时间：</p>
                <p>{{ item.applyStartTime }}—{{ item.applyEndTime }}</p>
                <div class="oparate">
                  <Button type="primary" shape="circle" class="btn1">
                    <router-link
                      :to="{
                        path: 'match-detail',
                        query: { contestId: item.id },
                      }"
                      >赛事详情</router-link
                    >
                  </Button>
                  <Button shape="circle" @click="isShowBat = true"
                    >排行榜</Button
                  >
                </div>
              </div>
            </Card>
            <span class="plusnum">
              <span>{{ item.contestAge }}</span>
            </span>
          </i-col>
        </Row>
      </div>
    </div>
    <div class="win-work-video" v-if="showWinWork">
      <svg-icon
        class="close"
        icon-class="close1"
        @click="
          showWinWork = false;
          winWorkVideoUrl = null;
        "
      ></svg-icon>
      <video
        v-if="winWorkVideoUrl.indexOf('.mp4') > -1"
        :src="winWorkVideoUrl"
        controls="controls"
      ></video>
      <img v-else :src="winWorkVideoUrl" alt="" />
    </div>
    <div class="jx wd">
      <div class="jb" v-if="showJb" @click="showJb = false">
        <svg-icon icon-class="jb"></svg-icon>
        <p>个人排行榜</p>
      </div>
      <div v-else class="jx-list">
        <svg-icon
          class="close"
          icon-class="close1"
          @click="showJb = true"
        ></svg-icon>
        <ul>
          <li v-for="(item, index) in userContestRank" :key="index">
            <Row type="flex" align="middle">
              <i-col span="5">
                <img
                  style="width: 50px; border-radius: 50px"
                  v-if="item.headimgurl"
                  :src="item.headimgurl"
                />
                <svg-icon v-else icon-class="a3"></svg-icon>
              </i-col>
              <i-col span="13">
                <p>{{ item.work_name }}</p>
                <span>作者：{{ item.realname }}</span>
              </i-col>
              <i-col span="4">{{ item.star_num }}赞</i-col>
            </Row>
          </li>
        </ul>
      </div>
    </div>
    <Modal class="course-modal" v-model="isShowCourse" width="920">
      <Row>
        <i-col span="8">
          <svg-icon class="m-img" icon-class="m1"></svg-icon>
          <p>全世界非常流行的编程语言，助你快速成为编程大师</p>
          <Button type="primary" shape="circle">
            <a href="/static/scratch3/index.html?scene=contest" target="_blank"
              >Scratch 3.0</a
            >
          </Button>
          <span class="plusnum">
            <span>6+</span>
          </span>
        </i-col>
        <i-col span="8">
          <svg-icon class="m-img" icon-class="m2"></svg-icon>
          <P>结合智能硬件实现多种程序效果，走进人工智能时代</P>
          <Button type="primary" shape="circle">
            <a href="javascript: void(0)">AI编程</a>
          </Button>
          <span class="plusnum">
            <span>7+</span>
          </span>
        </i-col>
        <i-col span="8">
          <svg-icon class="m-img" icon-class="m3"></svg-icon>
          <p>人工智能时代到来，python展示出无与伦比程序能力</p>
          <Button type="primary" shape="circle">
            <a href="javascript: void(0)">python</a>
          </Button>
          <span class="plusnum">
            <span>9+</span>
          </span>
        </i-col>
      </Row>
      <span slot="footer"></span>
    </Modal>
    <Modal
      class="battle-modal"
      v-model="isShowBat"
      :closable="false"
      width="600"
    >
      <svg-icon
        @click="isShowBat = false"
        icon-class="close"
        class="close"
      ></svg-icon>
      <svg-icon icon-class="b1" class="battle"></svg-icon>
    </Modal>
  </div>
</template>
<script>
import {
  contestList,
  getUserContestRank,
  getContestWinWork,
} from "@/api/contest";
import { userWorkList } from "@/api/community";
export default {
  name: "match",
  data() {
    return {
      isShowCourse: false,
      isShowBat: false,
      showJb: true,
      type: 1,
      contestResult: {},
      workList: [],
      winWork: [],
      list: [{}],
      jxList: [{}, {}, {}, {}],
      userContestRank: [],
      showWinWork: false,
      winWorkVideoUrl: null,
      caroulLength: "1"
    };
  },
  created() {
    this.contestList();
    this.getWorkList();
    this.getUserContestRank();
    this.getContestWinWork();
  },
  methods: {
    getList(type) {
      this.type = type;
    },
    getWorkList() {
      userWorkList(
        null,
        null,
        null,
        "contest",
        null,
        null,
        "star_num",
        false,
        1,
        40
      ).then((res) => {
        if (res.success) {
          this.workList = res.result.records;
          this.caroulLength = Math.ceil(
            this.workList.length / 8
          );

        }
      });
    },
    contestList() {
      contestList(1).then((res) => {
        if (res.success) {
          this.contestResult = res.result;
        }
      });
    },
    getContestWinWork() {
      getContestWinWork().then((res) => {
        if (res.success) {
          this.winWork = res.result.records;
        }
      });
    },
    getUserContestRank() {
      getUserContestRank().then((res) => {
        if (res.success) {
          this.userContestRank = res.result;
        }
      });
    },
    toDetail(workId) {
      this.$router.push({
        path: `/task-detail?workId=${workId}`,
      });
    },
    toFriend(userId) {
      this.$router.push({
        path: `/friends?userId=${userId}`,
      });
    },
  },
};
</script>
<style lang="scss">
.match {
  .list {
    font-weight: 700;
    background: #fff;
    border-radius: 10px;
    padding: 2px 15px;
    .ivu-list-item {
      position: relative;
      opacity: 0.7;
      padding: 15px 0;
      &:hover {
        opacity: 1;
      }
      .ivu-list-item-meta-title {
        color: #333;
        font-size: 15px;
        font-weight: 700;
      }
      .ivu-avatar {
        width: 95px;
        height: 66px;
        border-radius: unset;
      }
    }
  }
}
.course-modal {
  position: relative;
  .ivu-modal-footer {
    display: none;
  }
  .ivu-modal-body {
    padding: 60px 20px 40px 20px;
  }
  .ivu-modal-content {
    background-color: rgba(215, 215, 215, 1);
    border-radius: 8px;
  }
  .plusnum {
    right: 0;
    box-shadow: 2px 0px 4px 0 rgba(0, 0, 0, 0.3);
  }
}
.battle-modal {
  position: relative;
  .ivu-modal-footer {
    display: none;
  }
  .battle {
    width: 600px;
    height: 395px;
  }
  .ivu-modal-body {
    background-image: linear-gradient(45deg, #03cafd, #68efba);
    padding: 0;
    font-size: 0;
    border-radius: 6px;
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 38px;
    height: 33px;
  }
}
.plusnum {
  position: absolute;
  right: 12px;
  top: -20px;
  color: #fff;
  background: #fff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &::before {
    background: #ff0066;
    width: 38px;
    height: 38px;
    content: "";
    position: absolute;
    border-radius: 50%;
    right: 1px;
    top: 1px;
  }
}
</style>
<style lang="scss" scoped>
.match {
  text-align: left;
  .top-content {
    background: url("../../assets/match/bg.jpg") no-repeat -330px 0;
    background-size: 142% 86%;
    margin-top: -80px;
    padding-top: 80px;
    height: 450px;
    .carousel {
      overflow: unset !important;
      border-radius: 10px;
      .wrap {
        font-size: 30px;
        width: 977px;
        height: 346px;
        border-radius: 10px;
      }
    }
    .wrap-right {
      width: 239px;
      height: 211px;
    }
    .work {
      width: 239px;

      text-align: center;
      font-size: 18px;
      color: #333;
      p {
        background: #fff;
        margin-top: -4px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        line-height: 50px;
        &:nth-child(2) {
          border-radius: 10px;
          margin-top: 33px;
        }
      }
    }
  }
  .match-content {
    margin-top: 70px;
    margin-bottom: 30px;
    .title {
      .icon {
        font-size: 43px;
        vertical-align: middle;
      }
      .tip {
        color: #333;
        font-weight: 700;
        font-size: 24px;
        vertical-align: middle;
      }
    }
    .cards {
      margin-top: 30px;
      font-size: 13px;
      .card-list2 {
        width: 522px;
        margin-bottom: 50px;
        position: relative;
        &:nth-child(2n + 1) {
          margin-right: 60px;
        }
        .icon {
          border-radius: 10px;
          width: 522px;
          height: 277px;
        }
        .card-bottom {
          padding: 0 30px;
          .title {
            font-size: 16px;
            margin: 15px -30px;
            padding-left: 30px;
            .status {
              font-size: 14px;
              color: #ff3366;
              font-weight: 700;
              font-style: oblique;
              background: #d7d7d7;
              padding: 0 10px;
              line-height: 26px;
            }
          }
          p {
            padding-bottom: 15px;
          }
        }
        .oparate {
          position: absolute;
          bottom: 10px;
          right: 10px;
          button {
            border-color: rgb(255, 51, 102);
            color: rgb(255, 51, 102);
            &.btn1 {
              background: rgb(255, 51, 102);
              color: #fff;
              margin-right: 10px;
            }
          }
        }
      }
    }

    .card-list {
      margin-right: 40px;
      margin-bottom: 10px;
      .card {
        width: 230px;
        text-align: left;
        color: #999;
        .pic {
          width: 100%;
          height: 185px;
          overflow: hidden;
          img {
            width: 100%;
            height: 185px;
            transition: all 0.2s ease-out;
            opacity: 0.7;
            &:hover {
              opacity: 1;
            }
          }
        }
        .content {
          padding: 8px 20px;
          .title {
            color: #333;
            font-size: 14px;
          }
        }
        .footer {
          padding: 4px 20px;
        }
      }
    }
    .work-file {
      .list {
        margin-top: 24px;
        .grade {
          font-size: 20px;
          color: #f59a23;
          position: absolute;
          right: 0;
          bottom: 10px;
        }
      }
      p {
        font-size: 18px;
        text-align: center;
        font-weight: 400;
        line-height: 60px;
      }
    }
  }
  .win-work-video {
    position: fixed;
    width: 800px;
    height: 650px;
    top: 50%;
    left: 50%;
    margin: -350px 0 0 -400px;
    z-index: 9999;
    background: rgba(242, 242, 242, 1);
    border-radius: 10px;
    .close {
      float: right;
      width: 41px;
      height: 35px;
      color: red;
      padding: 5px;
    }
    video,
    img {
      width: 90%;
      margin: 0px 5%;
    }
  }
  .jx {
    .jb {
      position: fixed;
      left: 20px;
      top: 40%;
      z-index: 9999;
      svg {
        width: 90px;
        height: 90px;
      }
      p {
        font-weight: 700;
        font-size: 20px;
        color: #f59a23;
      }
    }
    .jx-list {
      width: 400px;
      position: fixed;
      right: 30px;
      top: 40%;
      max-height: 570px;
      overflow-y: scroll;
      z-index: 99999;
      .close {
        position: fixed;
        top: 41%;
        right: 70px;
        width: 22px;
        height: 22px;
        color: red;
      }
      li {
        margin-bottom: 10px;
        padding: 10px 20px;
        background-color: rgba(215, 215, 215, 1);
        border-radius: 70px;
        svg {
          width: 50px;
          height: 50px;
        }
        p {
          margin-bottom: 10px;
        }
        &:hover {
          background: rgba(202, 249, 130, 1);
        }
      }
    }
  }
}
.course-modal {
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑", sans-serif;
  font-size: 13px;
  color: #333;
  font-weight: 700;
  text-align: center;
  .m-img {
    width: 279px;
    height: 181px;
    margin-bottom: 30px;
  }
  p {
    width: 200px;
    height: 60px;
    margin: 0 auto 20px;
  }
  button {
    background: #22ade8;
    border-color: #22ade8;
    color: #fff;
    padding: 0 32px;
    line-height: 36px;
    height: 36px;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/match.vue